export class StreamUrl {
  streamurl?: string
  streamkey?: string
  valid = false
  url: string = ''

  constructor (url?: string) {
    this.url = url || ''
    this.__parse()
  }

  static stripStreamKey (url: string): string {
    return url.split('/').slice(0, -1).join('/')
  }

  fromUrlAndKey (streamurl: string, streamkey: string) {
    this.streamurl = streamurl
    this.streamkey = streamkey
    if (this.streamurl.endsWith('/')) {
      this.streamurl.slice(0, this.streamurl.length - 1)
    }
    this.url = this.streamurl + '/' + this.streamkey
  }

  __parse () {
    this.valid = false
    const args = this.url.split('/')
    if (args.length >= 5) {
      this.streamurl = args[0] + '//' + args[2] + '/' + args[3]
      this.streamkey = args.splice(4).join('/')
      this.valid = true
    }
  }
}
